import { AutoMap } from "@automapper/classes";

export class PointagePauseDTO {
    @AutoMap()
    debut!: string;
    @AutoMap()
    fin!: string;
}